// extracted by mini-css-extract-plugin
module.exports = {"Emoji":"zv_a bfq_i bfq_q bfq_j"};